export default __webpack_public_path__ + "static/media/Web_04-01.56d47056.png";